<template>
  <div v-editable="blok" class="menu-article">
    <div class="menu-article-label" v-text="blok.label" />
    <a class="menu-article-link" :href="getLinkFieldUrl(blok.link)" :target="blok.link?.target">
      <figure class="menu-article-image">
        <NuxtImg v-if="blok.image?.filename" provider="storyblok" loading="lazy" :src="blok.image.filename" :alt="`Article Image ${blok.image.alt}`" fetchpriority="low" class="menu-article-image-element" :width="315" :height="205" />
      </figure>
      <div class="menu-article-title" v-text="blok.title" />
      <div class="menu-article-description" v-text="stringTruncate(blok.description || '', 90)" />
      <span v-if="blok?.hide_read_more" class="menu-article-readmore">Read more</span>
    </a>
    <div class="menu-article-buttons">
      <StoryblokComponent v-for="button in blok.buttons" :key="button._uid" :blok="button" />
    </div>
  </div>
</template>
<script setup>
  defineProps({ blok: Object });
</script>
